import React, { useState } from "react";
//import { useParams } from 'react-router-dom';
//import { IoChevronBackCircle } from "react-icons/io5";
import { AppTableNoData } from 'components/common/AppTableUtils';
import AppPagination from "components/common/AppPagination";
//import ErrPersonsService from '../../services/errPerson.service';

const ErrorsForPerson = (props) => {
    const {person = {}, personType } = props;
    //const [data, setData] = useState(props.data);
    const data = props.data;
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });

   
    // const backhandler = () => {
    //     props.history.goBack();
    // }

    return (<>
     {personType!=="Crew"?<div>pnr: {person?.pnr} uniqueId: {person?.uniqueId}</div>:null}
     <div>First name: {person?.firstName} Last name: {person?.lastName}</div>
                        <div>Document number: {person?.travelDocumentNumber}</div>
<table className="table table-hover table-sm table-bordered">
                        <thead style={{ zIndex: 5 }}>
                        <tr>
                            <th scope="col">Error code</th>
                            <th scope="col">Error field name</th>
                            <th scope="col">Error field value</th>
                            
                                </tr>

                            </thead>
                            <tbody>
                                {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                                return (
                                  
                                <tr>
                                    <td style={{ textAlign: 'center' }}>{item.errorCode}</td>
                                    <td style={{ textAlign: 'center' }}>{item.errorFieldName}</td>
                                    <td style={{ textAlign: 'center' }}>  {item.errorFieldValue}</td>
                                    
                                </tr>
                                   )
                                })
                                }
                                </tbody>
                            </table>

       
                            {!data.length ? <AppTableNoData /> :
                            <AppPagination
                                pageSize={paginationObject.pageSize}
                                totalRecords={data.length}
                                currentPage={paginationObject.currPage}
                                endIndex={paginationObject.endIndex}
                                startIndex={paginationObject.startIndex}
                                setPaginationObject={(ele) => {
                                    setPaginationObject((data) => {
                                        return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                    })
                                }}
                            ></AppPagination>
                            }
                            </>)
                        }
     


export default ErrorsForPerson;